import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Sparkles, X, Circle, Square, Heart, Star } from 'lucide-react';
import LumeraCompanion from './LumeraCompanion';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FloatingCompanion = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const { t } = useLanguage();

  useEffect(() => {
    loadSavedAvatar();
  }, []);

  const loadSavedAvatar = async () => {
    const savedAvatarId = localStorage.getItem('selectedAvatarId');
    if (savedAvatarId) {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/companion/avatars`, {
          withCredentials: true
        });
        const avatar = response.data.avatars.find(a => a.id === savedAvatarId);
        if (avatar) {
          setSelectedAvatar(avatar);
        }
      } catch (error) {
        console.error('Error loading avatar:', error);
      }
    }
  };

  const getAvatarIcon = () => {
    if (!selectedAvatar) return <Sparkles className="w-6 h-6 md:w-8 md:h-8 text-white" />;
    
    const iconClass = "w-6 h-6 md:w-8 md:h-8 text-white";
    switch (selectedAvatar.shape) {
      case 'circle':
        return <Circle className={iconClass} />;
      case 'square':
        return <Square className={iconClass} />;
      case 'heart':
        return <Heart className={iconClass} />;
      case 'star':
        return <Star className={iconClass} />;
      default:
        return <Sparkles className={iconClass} />;
    }
  };

  return (
    <>
      {/* Floating Action Button - Mobile Optimized */}
      <Button
        onClick={() => setIsOpen(true)}
        data-testid="floating-companion-fab"
        className="fixed bottom-4 right-4 md:bottom-6 md:right-6 w-14 h-14 md:w-16 md:h-16 rounded-full shadow-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 hover:from-pink-600 hover:via-purple-600 hover:to-blue-600 z-50 flex items-center justify-center transition-all hover:scale-110 active:scale-95 animate-pulse"
        aria-label={t('talkToCompanion')}
      >
        {getAvatarIcon()}
      </Button>

      {/* Full-screen Modal - Mobile Optimized */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-full md:max-w-5xl h-screen md:h-[90vh] p-0 gap-0 bg-white dark:bg-slate-900 m-0 md:m-4 overflow-hidden">
          <DialogHeader className="p-3 md:p-4 border-b border-slate-200 dark:border-slate-700 flex-row items-center justify-between space-y-0 shrink-0">
            <DialogTitle className="text-base md:text-xl flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-purple-600" />
              <span className="truncate">Lumera Companion</span>
            </DialogTitle>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsOpen(false)}
              className="h-9 w-9 md:h-8 md:w-8 p-0 flex-shrink-0"
            >
              <X className="w-5 h-5" />
            </Button>
          </DialogHeader>
          <div className="flex-1 overflow-hidden">
            <LumeraCompanion />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingCompanion;
